import { __extends } from "tslib";
import React from 'react';
import { withMobileContext, } from '@wix/da-react-context/pkg/MobileContext';
import Grid from '../../../Grid';
import s from './TierGrid.scss';
var TierGrid = /** @class */ (function (_super) {
    __extends(TierGrid, _super);
    function TierGrid() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getTierId = function (index) {
            var _a = _this.props.tiers, tiers = _a === void 0 ? [] : _a;
            var item = tiers[index];
            return item.deviationId;
        };
        _this.renderTier = function (_a) {
            var style = _a.style, width = _a.width, index = _a.index;
            var tierRenderer = _this.props.tierRenderer;
            return React.createElement("div", { style: style }, tierRenderer({ index: index, width: width }));
        };
        return _this;
    }
    TierGrid.prototype.render = function () {
        var _a = this.props, tiers = _a.tiers, cookieType = _a.cookieType, isMobile = _a.isMobile;
        if (!tiers) {
            return null;
        }
        return (React.createElement(Grid, { className: s['root'], breakpoints: [
                { maxWidth: 0, elementWidth: 130, elementHeight: 106 },
                { maxWidth: 451, elementWidth: 270, elementHeight: 220 },
            ], cookieType: cookieType, elementCount: tiers.length, getElementId: this.getTierId, renderElement: this.renderTier, spacing: isMobile ? 10 : 16, enableScrollOptim: false }));
    };
    return TierGrid;
}(React.Component));
export { TierGrid };
export default withMobileContext(TierGrid);
//# sourceMappingURL=TierGrid.js.map